module.exports = __webpack_public_path__ + "img/PDF.534e5a66.png";